// KnowledgeId.js
// Purpose: Displays and manages the details of a specific knowledge base entry, including fetching data and handling pagination.
// Logic: Uses React hooks to fetch, store, and update knowledge base data, and manages UI state for loading and pagination.

import React, { useCallback, useEffect, useRef, useState } from "react";
// import TableComponent from "../components/TableComponent";
import EditableTable from "../components/EditableTable";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { socketService } from "../components/socketService";
import { clog, isUserOwnerOfWorkspace } from "../lib/utils";

function KnowledgeId() {
  const navigate = useNavigate();
  const [knowledgeBaseRows, setknowledgeBaseRows] = useState({});
  const [knowledgeBaseRowsData, setknowledgeBaseRowsData] = useState([]);
  const [pageInfo, setpageInfo] = useState({});
  const [loadingList, setloadingList] = useState(true);
  const isOwner = isUserOwnerOfWorkspace();
  // Function to fetch knowledge base details by ID with pagination
  const getKnowledgeIdData = async (id, offset = 0, limit = 20) => {
    setloadingList(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/knowledgebase_details`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          knowledge_id: id,
          offset, // Adding offset
          limit, // Adding limit
        },
      });

      if (!response.data.error) {
        setknowledgeBaseRowsData((prev) => {
          const newData = response?.data?.data || [];
          const existingIds = new Set(prev.map((item) => item?.id)); // Store existing knowledge_ids

          const filteredData = newData.filter(
            (item) => !existingIds.has(item?.id)
          ); // Remove duplicates

          return [...prev, ...filteredData]; // Append only unique items
        });

        setknowledgeBaseRows(response?.data);
        setpageInfo(response?.data?.pageInfo);
      }
    } catch (error) {
      clog(error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloadingList(false);
    }
  };
  // Retrieve selected knowledge base from local storage
  let selectedKnowledgeBase = JSON.parse(
    localStorage.getItem("selected-knowledge-base")
  );
  // Create observer reference
  const observerRef = useRef();

  // Create callback for intersection observer
  const lastElementRef = useCallback(
    (node) => {
      if (loadingList) return;

      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && pageInfo?.hasNextPage) {
          clog("Visible");
          getKnowledgeIdData(
            selectedKnowledgeBase?.knowledge_id,
            knowledgeBaseRowsData?.length,
            20
          ); // Corrected offset
        }
      });

      if (node) {
        observerRef.current.observe(node);
      }
    },
    [loadingList, pageInfo?.hasNextPage, knowledgeBaseRowsData.length] // Added missing dependencies
  );
  // Effect to fetch initial knowledge base data when component mounts
  useEffect(() => {
    let selectedKnowledgeBase = JSON.parse(
      localStorage.getItem("selected-knowledge-base")
    );
    if (selectedKnowledgeBase) {
      getKnowledgeIdData(selectedKnowledgeBase?.knowledge_id);
    }
  }, []);
  // Effect to initialize socket service and handle notifications
  useEffect(() => {
    if (!socketService.isConnected()) {
      socketService.initialize();
    }
    // Handle notifications
    // notify("Welcome to the Knowledge Base");
    const handleNotification = (data) => {
      //example data
      // {
      //   contents:'Job Success for Manual agent process ',
      //   knowledge_id:knowledge_id,
      //   content_id: content_id.toString()
      //}
      clog("AsideBar notification:", data);
      // let toastMessage = data?.contents || "";
      // let status = data?.status;
      // if (status == 2) {
      //   notify(toastMessage, "success");
      // } else {
      //   notify(toastMessage, "error");
      // }
      getKnowledgeIdData(data?.knowledge_id);
    };

    socketService.on("keyword_notification", handleNotification);
    socketService.on("knowledge_notification", handleNotification);

    return () => {
      socketService.off("keyword_notification", handleNotification);
      socketService.off("knowledge_notification", handleNotification);
    };
  }, []);
  clog(knowledgeBaseRows, "knowledgeBaseRows");

  return (
    <div>
      <EditableTable
        loadingList={loadingList}
        knowledgeBaseRows={knowledgeBaseRows}
        knowledgeBaseRowsData={knowledgeBaseRowsData || []}
        getKnowledgeIdData={getKnowledgeIdData}
        lastElementRef={lastElementRef}
        isOwner={isOwner}
      />
    </div>
  );
}

export default KnowledgeId;
